import { unparse } from 'papaparse';

export const getCsvUrl = (
  rows: Record<string, string | number | undefined | null | boolean>[]
) => {
  const csv = unparse(rows, {
    quotes: true,
    escapeChar: '/',
    skipEmptyLines: true,
  });

  // 2. Add UTF-8 BOM
  const csvWithBOM = `\uFEFF${csv}`;
  const csvData = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });

  return window.URL.createObjectURL(csvData);
};
